import React from 'react';
import {useIntl} from 'react-intl';
import dateFormat from 'dateformat';

import {useLocalesMgr} from 'coreHooks';

import {EDateComponentType, IDateComponentProps} from './IDateComponent';

const DateComponent = ({
	value,
	showLocalizedDate = true,
	dateType = EDateComponentType.DATE_SHORT,
	timeStyle,
	...props
}: IDateComponentProps) => {
	const intl = useIntl();
	const localesMgr = useLocalesMgr();
	const localeSettings = localesMgr.getCurrentCountry().getLocaleSettings();
	const date = new Date(value);

	//TODO: needed to synch with SF formatter, remove once the checkout is removed
	const SF_MAPPING = [{
		search: 'MMM',
		replace: 'mmm'
	}, {
		search: 'MM',
		replace: 'mm'
	}];

	const formattedDate = () => {
		if (showLocalizedDate) {
			return Intl.DateTimeFormat(intl.locale, {
				dateStyle: 'short',
				timeStyle: (timeStyle === null) ? undefined : timeStyle || 'short',
				...props
			}).format(date);
		} else {
			const formatter = SF_MAPPING.reduce((formatter, o, ) =>
				formatter.replace(o.search, o.replace), localeSettings[dateType]);

			return dateFormat(date, formatter);
		}
	};

	return <span className="date">{value ? formattedDate() : '-/-/-'}</span>;
};

export default DateComponent;
